import { useState } from "react";
import apiService from "services/api";
import { useHistory } from "react-router-dom";
import { useNotificationContext } from "contexts";
import { useForm } from "react-hook-form";
import { FormGroup, Label, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { capitalize } from "utils/capitalize";
import { titleCase } from "utils/titleCase";
import { permissionCategories, permissionActions } from "./constants";
import { centreOptions } from "constants";

const PermissionOptions = ({ name, register }) => (
	<div className="row ml-2 mb-4">
		<div className="col-12 col-sm-3 mt-2 text-light">
			{name.split("_").map(capitalize).join(" ")} :{" "}
		</div>

		<div className="col-12 col-sm-9 d-flex flex-wrap">
			{permissionActions.map(([label, value], index) => (
				<div
					className="mr-2 border border-primary rounded px-2 py-1 form-check"
					key={index}
				>
					<label className="form-check-label">
						<input
							className="form-check-input"
							type="checkbox"
							{...register(`${name}.${value}`)}
						/>
						<span className="form-check-sign"></span>
						<small className="text-primary">
							{titleCase(label)}
						</small>
					</label>
				</div>
			))}
		</div>
	</div>
);

const NewRolePage = () => {
	const history = useHistory();

	const { register, handleSubmit } = useForm();
	const [showLoading, setShowLoading] = useState(false);

	const { createNotification } = useNotificationContext();

	const parseFormInput = (tempFormBody) => {
		var formBody = {};
		Object.keys(tempFormBody).forEach((key) => {
			if (key === "name") return (formBody.name = tempFormBody.name);
			if (key === "centre")
				return (formBody[key] = Object.keys(tempFormBody[key])
					.filter((action) => tempFormBody[key][action])
					.join(":"));
			formBody[key] = Object.keys(tempFormBody[key])
				.map((action) => (tempFormBody[key][action] ? action : ""))
				.join("");
		});
		return formBody;
	};

	const submitNewMenuItemForm = async (data) => {
		setShowLoading(true);
		const formBody = parseFormInput(data);
		apiService.role
			.create(formBody)
			.then(() => {
				createNotification({
					type: "success",
					message: "Successfully created a new role",
				});
				history.push("/role");
			})
			.catch((error) =>
				createNotification({
					type: "danger",
					message: `Failed to create a new role: ${error.message}`,
				})
			)
			.finally(() => setShowLoading(false));
	};

	return (
		<form
			onSubmit={handleSubmit(submitNewMenuItemForm)}
			className="content"
		>
			<h5 className="text-center mb-4">New Role</h5>
			<div className="d-flex justify-content-center">
				<div className="w-75">
					<div className="mb-5">
						<Link to="/role" className="btn btn-sm btn-info my-3">
							&lt; Back to roles
						</Link>
					</div>
					<div className="mb-3">
						<FormGroup className="mb-1">
							<Label for="Title" className="text-white">
								Name
							</Label>
						</FormGroup>
						<input
							className="form-control"
							placeholder="Role Name"
							{...register("name")}
						/>
					</div>
					<div className="mb-3">
						<FormGroup className="mb-1">
							<Label for="Description" className="text-white">
								Permissions
							</Label>
						</FormGroup>
						{permissionCategories.map((permission, key) => (
							<PermissionOptions
								key={key}
								name={permission}
								register={register}
							/>
						))}
					</div>
					<div className="row ml-2 mb-4">
						<div className="col-12 col-sm-3 mt-2 text-light">
							Centre:
						</div>
						<div className="col-12 col-sm-9 d-flex flex-wrap">
							{centreOptions.map(({ label, value }, index) => (
								<div
									className="mr-2 border border-primary rounded px-2 py-1 form-check"
									key={index}
								>
									<label className="form-check-label">
										<input
											className="form-check-input"
											type="checkbox"
											{...register(`centre.${value}`)}
										/>
										<span className="form-check-sign"></span>
										<small className="text-primary">
											{titleCase(label)}
										</small>
									</label>
								</div>
							))}
						</div>
					</div>
					<div className="d-flex justify-content-end mt-5">
						{showLoading ? (
							<Button color="primary" disabled={true}>
								<span className="spinner-border"></span>
							</Button>
						) : (
							<Button color="primary" type="submit">
								Submit
							</Button>
						)}
					</div>
				</div>
			</div>
		</form>
	);
};

export default NewRolePage;
